import React from 'react';
import { Atomic, Product } from '@atomicfi/transact-javascript';
import { useComplexState } from 'hook/helper.hook';
import { useEffect } from 'react';

const AtomicSDKWrapper = props => {
  const [state, setState] = useComplexState({
    showingAtomic: false,
  });
  const { publicToken } = props;

  useEffect(() => {
    if (props.isVisible && !state.showingAtomic) {
      const atomicMetadata = Atomic.transact({
        config: {
          publicToken,
          tasks: [{ product: Product.DEPOSIT }],
          deeplink: {
            step: 'search-company',
          },
          handoff: ['exit-prompt'],
        },
        onInteraction: interaction => {
          if (props.filterAtomicEvents) {
            props.filterAtomicEvents(interaction.name, interaction.value);
          }
        },
        onFinish: data => {
          setState({ showingAtomic: false });
          if (props.onAtomicFinish) {
            props.onAtomicFinish(data);
          }
        },
        onClose: data => {
          setState({ showingAtomic: false });
          if (props.onAtomicClose) {
            props.onAtomicClose(data);
          }
        },
      });

      setState({ showingAtomic: true });
      return () => {
        if (atomicMetadata) {
          atomicMetadata?.close();
        }
      };
    }
    //eslint-disable-next-line
  }, [props.isVisible]);

  return <div id="atomic-sdk-wrapper" />;
};

export default AtomicSDKWrapper;
